import Image from "next/image";
import styles from "./Footer.module.scss";

declare global {
  interface Window {
    OneTrust: any;
  }
}

export const Footer = function () {
  return (
    <footer className="footer" id="lp_footer">
      <div className={styles.footerSection}>
        <section className={styles.content}>
          <div className={styles.links}>
            <p>
              <a
                href=""
                target="_self"
                onClick={function (event) {
                  event.preventDefault();

                  if (typeof window.OneTrust === "undefined") {
                    console.error("Error: OneTrust is not defined");
                    return;
                  }

                  window.OneTrust.ToggleInfoDisplay();
                }}
              >
                Your Privacy Choices
              </a>
            </p>
            <span>
              Contact us:{" "}
              <a href="mailto:harvardbok@getsmarter.com" target="_blank">
                harvardbok@getsmarter.com
              </a>{" "}
              | <a href="tel:+16176827555">+1 617 682 7555</a>
            </span>
            <span>
              GetSmarter and{" "}
              <a href="https://www.edx.org/" target="_blank">
                edX
              </a>{" "}
              are owned by 2U.
            </span>
            <p className={styles.disclaimer}>
              Copyright ©2025 GetSmarter. All rights reserved |{" "}
              <a href="https://www.getsmarter.com/privacy-policy" target="_blank">
                Privacy Policy
              </a>{" "}
              |{" "}
              <a href="https://www.getsmarter.com/cookie-policy" target="_blank">
                Cookie policy
              </a>
            </p>
          </div>
          <div className={styles.logo}>
            <a href="https://www.getsmarter.com/" target="_blank">
              <Image
                src="https://www.getsmarter.com/presentations/wp-content/themes/tailored-pages/assets/gs-in-collaboration-with-logo-tm.png"
                alt="MIT AI"
                width={239}
                height={35}
              />
            </a>
          </div>
        </section>
      </div>
    </footer>
  );
};
